<template>
  <div class="search">
    <div class="serachkuang">
      <input :placeholder="placeholder" v-model="name"  @keydown.enter="search"/>
      <div class="sousuo" @click="search">
        <a href="#"><img src="../../src/assets/img/search.png" /></a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['placeholder'],
    components: {},
    data() {
      return {
        name
      };
    },
    computed: {},
    methods: {
      search(){
        console.log(this.name)
        this.$emit("search",this.name)
      },
      clear(){
        this.name = ''
      }
    },
    mounted() {},
  };
</script>
<style scoped>
  .serachkuang img {
    padding: 9px 15px 9px 15px;
    background: red;
    border-radius: 0 6px 6px 0;
  }

  .serachkuang input {
    border: none;
    width: 630px;
    height: 48px;
    background: #f5f7fa;
    opacity: 1;
    border-radius: 6px 0px 0px 6px;
    padding-left: 15px;
  }

  ::-webkit-input-placeholder {
    color: #999999;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .search {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    /* background: #F53824; */
    width: 100%;
    height: 70px;
  }

  @media (max-width: 750px) {
    body {
      width: 100%;
      height: auto;
    }

    .search {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .serachkuang {
      width: 80%;
      height: 48px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/vSerchmy.vue